import { FormattedMessage } from 'react-intl';

import SelectAmountWithSlider from '../../../ui/selectAmountWithSlider/SelectAmountWithSlider';

const RepaymentSelectAmount = (props: {
    selectedInputAmount: number | null;
    outstandingBalance: number | null;
    updateSelectedAmount: (inputAmount: number, sliderAmount: number) => void;
    requestSelectedAmount: () => void;
    initialValues?: { amount: string };
}) => {
    const { selectedInputAmount, outstandingBalance } = props;

    return (
        <SelectAmountWithSlider
            name="Select Repayment Amount"
            selectedAmount={selectedInputAmount}
            maxValue={outstandingBalance ?? 0}
            minValue={1} /**TODO: get this from the API */
            {...props}
        >
            <FormattedMessage
                id="_.early_repayment.choose_repayment_amount.repay_amount"
                defaultMessage="I want to repay"
            />
        </SelectAmountWithSlider>
    );
};

// eslint-disable-next-line import/no-default-export
export default RepaymentSelectAmount;
